// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"panel-toolbar_toolbar__7ma_R","toolbarButton":"panel-toolbar_toolbarButton__K1Um1"};